module.exports = __webpack_public_path__ + "img/Monte_Kope_64.7b9e3fae.jpg";